<template>
  <div id="app">
    <div v-show="!started">
      <header>
        <h1>Jigsaw</h1>
        <p>
          Play with your own pictures.
          (<a href="https://gitlab.com/experimentslabs/games/jigsaw" target="_blank" rel="noreferrer">Source code</a>)
        </p>
      </header>

      <h2>How to play</h2>
      <ul>
        <li>Select an image from your hard drive, an URL or one of the selected ones.</li>
        <li>Select the amount of tiles horizontally. The tiles are squares, to the picture may be slightly truncated in game.</li>
        <li>Start the game</li>
        <li>Click on a tile to select it, and on another to swap them.</li>
        <li>Repeat until you completed the picture.</li>
      </ul>

      <jigsaw-form @start="start" />
    </div>

    <div id="game" class="game-wrapper" :class="gameCSS" />
    <div v-if="started" class="score">
      Time: {{ time }}s -
      Clicks: {{ clicks }} -
      Placed: {{ wellPlaced }} / {{ totalTiles }}
    </div>
    <div v-if="win" class="win">You win ! <button type="button" class="btn--start btn--win" @click="reset">Reset</button></div>

    <jigsaw-controls v-if="started && !win"
                     :game="game"
                     @reset="reset"
                     @resolve="resolve"
                     @mode="setMode" />
  </div>
</template>

<script>
import { Jigsaw } from './lib/jigsaw'
import JigsawForm from './components/JigsawForm'
import JigsawControls from './components/JigsawControls'

const timeout = 100

export default {
  name: 'App',
  components: { JigsawForm, JigsawControls },
  data () {
    return {
      game: null,
      started: false,
      wellPlaced: 0,
      totalTiles: 0,
      clicks: 0,
      mode: '',
      win: false,
      timer: null,
      ms: 0,
    }
  },
  computed: {
    gameCSS () {
      return `${this.mode}${this.win ? ' won' : ''}`
    },
    time () {
      return this.ms * timeout / 1000
    },
  },
  methods: {
    start ({ image, tilesX }) {
      this.game = new Jigsaw(image, {
        gameElement: document.getElementById('game'),
        tilesX: tilesX,
        onStart: () => {
          this.ms = 0
          this.timer = setInterval(() => {
            this.ms++
          }, 100)
        },
        onUpdate: ({ wellPlaced, total, clicks }) => {
          this.totalTiles = total
          this.wellPlaced = wellPlaced
          this.clicks = clicks
        },
        onWin: () => {
          this.win = true
          this.game.freeze()
          clearInterval(this.timer)
        },
      })
      this.started = true
      this.game.start()
    },
    resolve () {
      this.game.resolve()
    },
    reset () {
      this.started = false
      this.game.destroy()
      this.game = null
      this.win = false
      clearInterval(this.timer)
    },
    setMode (mode) {
      this.mode = mode
    },
  },
}
</script>

<style lang="scss">
  @import "stylesheets/application";
</style>
